import { faqNav } from "@/mixins/faqNav";

export const DEFAULT_FAQ_BLOCK = faqNav[0]?.block ?? "mainBlock";

export const readRouteParam = (value) => {
    if (Array.isArray(value)) {
        return value[0] ?? null;
    }

    return value ?? null;
};

const createNavIndex = () => {
    const blocks = new Map();
    const sections = new Map();

    faqNav.forEach((item) => {
        blocks.set(item.block, item);
        sections.set(
            item.block,
            new Map((item.children ?? []).map((child) => [child.section, child]))
        );
    });

    return { blocks, sections };
};

const navIndex = createNavIndex();

export const blockHasSections = (block) => {
    return (navIndex.sections.get(block)?.size ?? 0) > 0;
};

export const getFirstSection = (block) => {
    const firstChild = navIndex.blocks.get(block)?.children?.[0];
    return firstChild?.section ?? null;
};

export const normalizeFaqParams = (params = {}) => {
    const requestedBlock = readRouteParam(params.block);
    const block = navIndex.blocks.has(requestedBlock)
        ? requestedBlock
        : DEFAULT_FAQ_BLOCK;

    if (!blockHasSections(block)) {
        return {
            block,
            section: null,
        };
    }

    const requestedSection = readRouteParam(params.section);
    const isValidSection = navIndex.sections.get(block)?.has(requestedSection);

    return {
        block,
        section: isValidSection ? requestedSection : getFirstSection(block),
    };
};

export const getFaqRouteLocation = (block = DEFAULT_FAQ_BLOCK, section = null) => {
    const safeBlock = navIndex.blocks.has(block) ? block : DEFAULT_FAQ_BLOCK;

    if (!blockHasSections(safeBlock)) {
        return {
            name: "faq",
            params: { block: safeBlock },
        };
    }

    const safeSection = navIndex.sections.get(safeBlock)?.has(section)
        ? section
        : getFirstSection(safeBlock);

    return {
        name: "faq",
        params: {
            block: safeBlock,
            section: safeSection,
        },
    };
};

export const getFaqLabel = (block, section = null) => {
    if (section) {
        return (
            navIndex.sections.get(block)?.get(section)?.label ??
            navIndex.blocks.get(block)?.label ??
            "FAQ"
        );
    }

    return navIndex.blocks.get(block)?.label ?? "FAQ";
};
